import type { FC, ReactNode } from 'react'
import type { HomeContent } from '@/types'

import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import { homeContent } from '@/constants/home-content'
import SiteHeader from '@/components/landing/site-header'
import HeroSection from '@/components/landing/hero-section'
import SiteFooter from '@/components/landing/site-footer'

import {
    CtaSection,
    FactsSection,
    FaqSection,
    FindsSection,
    HighlightsSection,
    IntroSection,
    QuoteSection
} from '@/components/landing/content-sections'

const Home: FC = (): ReactNode => {
    const { page, highlights, finds, facts, faqs }: HomeContent = homeContent

    return (
        <Layout>
            <Seo />

            <SiteHeader />

            {page ? (
                <>
                    <HeroSection page={page} />
                    <IntroSection page={page} />
                    <HighlightsSection page={page} items={highlights} />
                    <FindsSection page={page} items={finds} />
                    <QuoteSection page={page} />
                    <FactsSection page={page} items={facts} />
                    <FaqSection page={page} items={faqs} />
                    <CtaSection page={page} />
                </>
            ) : (
                <section id='hero' className='flex min-h-svh items-center justify-center px-6'>
                    <p className='max-w-md text-center text-lg text-muted-foreground'>
                        The page content could not be loaded right now. Please try again in a moment.
                    </p>
                </section>
            )}

            <SiteFooter text={page?.footerText ?? null} />
        </Layout>
    )
}

export default Home
